import { business, serviceAreas } from '../../../shared/config/site';

/**
 * Answers the only question a local visitor has before they call: do you come
 * to me? Named places, not "greater Johannesburg".
 *
 * The page's one bone band. The marquee, kit and training bands that used to
 * break up the ink were cut, and this is the section that earns the flip.
 */
export function Coverage() {
  return (
    <section id="coverage" className="u-band u-defer bg-[color:var(--color-surface-bone)]">
      <div className="u-shell grid gap-12 lg:grid-cols-[1fr_1.15fr] lg:gap-20">
        <div>
          <p className="u-label mb-6 text-[color:var(--signal-600)]">Coverage</p>
          <h2 className="u-balance u-display max-w-[12ch] text-[clamp(1.75rem,3.6vw,3rem)] text-[color:var(--color-text-on-bone)]">
            Out of Jet Park, across the East Rand
          </h2>
          <p className="u-measure mt-6 text-[color:var(--color-text-on-bone-muted)]">
            The office is at {business.address.street}, {business.address.suburb}.
          </p>

          <a
            href={business.mapsListingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="u-label mt-8 inline-flex min-h-[44px] items-end gap-2 border-b border-[color:var(--signal-500)] pb-1 text-[color:var(--color-text-on-bone)] transition-colors hover:text-[color:var(--signal-600)]"
            style={{ transitionDuration: 'var(--t-state)', transitionTimingFunction: 'var(--e-settle)' }}
          >
            {business.rating.value} from {business.rating.count} reviews on {business.rating.sourceLabel}
          </a>
        </div>

        <div>
          <ul className="grid grid-cols-1 gap-x-8 sm:grid-cols-2 lg:mt-2">
          {serviceAreas.map((area, index) => (
            <li key={area} className="u-rule-bone flex items-baseline gap-5 py-5">
              <span className="u-label text-[color:var(--signal-600)]">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="u-display min-w-0 text-[clamp(1.35rem,2vw,1.6rem)] text-[color:var(--color-text-on-bone)]">
                {area}
              </span>
            </li>
          ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
